function CodeOfConduct() {
  const rules = [
    "Students must maintain honesty, discipline, integrity, ethics and values.",
    "Students are accountable for their conduct inside and outside school premises.",
    "Students should move in a single line without disturbing other classes.",
    "Birthdays will be acknowledged by class teachers. Cakes and gifts are not allowed.",
    "Do not bring expensive items to school.",
    "School is not responsible for lost belongings.",
    "Any objectionable behavior may result in disciplinary action.",
    "Irregular attendance and misconduct can lead to expulsion.",
    "Students cannot leave campus during school hours.",
    "Maintain neat classrooms and a litter-free campus.",
    "Proper school uniform is mandatory.",
    "Students must respect school property.",
    "Vehicles parked near school are at owner's risk.",
    "Disciplinary action will be taken against habitual offenders.",
    "Students must follow all rules mentioned in the school almanac.",
  ];

  return (
    <section className="py-16 px-6 bg-gray-50 min-h-screen">
      <div className="max-w-6xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-blue-900 mb-4">
            Code Of Conduct
          </h1>

          <p className="text-gray-600 max-w-3xl mx-auto">
            Capitol Public School expects every student to maintain discipline,
            respect, responsibility and good moral conduct both inside and
            outside the campus.
          </p>
        </div>

        {/* Rules Grid */}
        <div className="grid md:grid-cols-2 gap-6">

          {rules.map((rule, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md p-6 hover:shadow-xl transition duration-300 border-l-4 border-yellow-400"
            >
              <div className="flex items-start gap-4">

                <div className="bg-blue-900 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold shrink-0">
                  {index + 1}
                </div>

                <p className="text-gray-700 leading-relaxed">
                  {rule}
                </p>

              </div>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
}

export default CodeOfConduct;